<template>
  <div class="AllTrend" :style="style">
    <pull-to
        :top-load-method="refresh"
        @top-state-change="topStateChange"
        :bottom-load-method="loadmore"
        @bottom-state-change="bottomStateChange"
        :top-block-height="10"
        :bottom-block-height="10"
        style="font-size: 14px;color: #aaa;"
    >
      <trend-content :allTrend="allTrend" :refreshUrl="refreshData"></trend-content>
      <div v-show="loading"><img src="@/assets/img/loading.gif" style="margin: 30px auto;"></div>
      <div v-show="nomore" style="margin: 0 auto 20px;text-align: center;color: #aaa;font-size: 14px;">没有更多了</div>
      <div v-show="nodata"  style="margin: 80px 70px; width: 40%;">
        <img src="@/assets/img/nodata.png">
        <span style="color: #aaa;margin-left: 70px;font-size: 14px;">暂无数据</span>
      </div>
    </pull-to>
  </div>
</template>

<script>
import PullTo from 'vue-pull-to'
import {getMoment} from "../../api/trend";
import Trend from './Trend'

export default {
  name: "AllTrend",
  components:{
    PullTo,
    Trend
  },
  data () {
    return {
      alllist:false,
      limit_begin: 0,
      limit_num: 20,
      type: 0,
      allTrend:[],
      nodata:false,
      nomore:false,
      loading:false,
      userInfo:this.$store.state.userInfo,
      refreshData:{
        limit_begin: 0,
        limit_num: 20,
        type: 0
      },
      style:{}
    }
  },
  created() {
    this.currentHeight()
  },
  mounted() {
    this.userInfo;
    this.nomore=false;
    this.getAllTrend({
      limit_begin: this.limit_begin,
      limit_num: this.limit_num,
      type: this.type
    });
  },
  activated() {
    this.allTrend=[]
    this.limit_begin=0
    this.getAllTrend({
      limit_begin: this.limit_begin,
      limit_num: this.limit_num,
      type: this.type
    });
  },
  methods: {
    getAllTrend(data) {
      getMoment(data)
          .then(res => {
            if(res.data.list.length == 0){
              this.nodata=true;
            }else{
              this.alllist=true;
              this.allTrend = res.data.list
              this.limit_begin=0
              this.limit_begin = this.limit_begin+res.data.count
            }
          }).catch(error => {
            console.log(error)
      })
    },
    refresh(loaded) {
      this.limit_begin = 0
      getMoment({
        limit_begin: this.limit_begin,
        limit_num: 20,
        type: this.type
      })
          .then((res) => {
            if(res.data.count>0){
              this.allTrend = res.data.list
              this.limit_begin = res.data.count
              this.nomore = false;
            }else{
              this.nomore = true;
            }
            loaded('done')
          })
    },
    topStateChange(state) {
      if (state === 'pull' || state === 'trigger') {
        this.iconLink = '#icon-arrow-bottom';
      } else if (state === 'loading') {
        this.iconLink = '#icon-loading';
      } else if (state === 'loaded-done') {
        this.iconLink = '#icon-finish';
      }
    },
    loadmore(loaded) {
      getMoment({
        limit_begin: this.limit_begin,
        limit_num: this.limit_num,
        type: this.type
      }).then(res => {
        if(res.data && res.data.count == 0){
          this.nomore=true
        }else{
          this.nomore=false
          this.allTrend = this.allTrend.concat(res.data.list);
          this.limit_begin = this.limit_begin+res.data.count
        }
        loaded('done');
      })
    },
    bottomStateChange(state) {
      if (state === 'pull' || state === 'trigger') {
        this.iconLink = '#icon-arrow-bottom';
      } else if (state === 'loading') {
        this.iconLink = '#icon-loading';
      } else if (state === 'loaded-done') {
        this.iconLink = '#icon-finish';
      }
    },
    currentHeight(){
      this.style.height = window.innerHeight-150 + 'px'
    }
  }
}
</script>

<style scoped>
.AllTrend{
  margin-top: 100px;
  /*height: 1000px;*/
}
</style>
